
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { Product } from "../models/product.model";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { Block } from "../models/block.model";

@Injectable({
    providedIn: 'root'
})

export class ReceiptsService {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {
    }

    saveReceipt(rekbotID : number, payload: object) {
        const endpoint = environment.apiUrl + "/api/receipt/" + rekbotID;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(
            endpoint, 
            payload, 
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })

    }

    fetchBlocks() {
        const endpoint = environment.apiUrl + "/api/blocks";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    fetchReceipt(rekbotID : number) {
        const endpoint = environment.apiUrl + "/api/receipt/" + rekbotID;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})

    }

    updateBlock(block: Block ) {
        const endpoint = environment.apiUrl + "/api/blocks/" + block.id  ;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(
            endpoint, 
            block, 
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            });

    }

    addBlock(block: Block ) {
        const endpoint = environment.apiUrl + "/api/blocks/";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.post(
            endpoint, 
            block, 
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            });
    }

    deleteBlock(block: Block ) {
        const endpoint = environment.apiUrl + "/api/receipts/blocks/delete/" + block.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.delete(
            endpoint, 
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            });
    }

}